import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ListadaAgrupada, ConfigService } from '../../../infrastructure/services/config.service';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Component({
  templateUrl: './product.setup.component.html',
})
export class ProductSetupComponent implements OnInit, OnDestroy {
  codOrganization:string;
  codSubscription: string;
  codChannel: string;
  codProduct: string;

  grupos: Observable<ListadaAgrupada[]>;
  cargando: Boolean = true;
  subsGetConfiguracion: Subscription;

  constructor(private aRoute: ActivatedRoute, private configService: ConfigService) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
        // Parametros URL
        this.codOrganization =params['codorganizacion'];
        this.codSubscription = params['codsistema'];
        this.codChannel = params['codnegocio'];
        this.codProduct = params['codproducto'];
        this.grupos = this.configService.
        getConfiguracion(
          this.codOrganization,
          this.codSubscription, 
          this.codChannel, 
          this.codProduct);
    });
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/product/product.setup.component.ts